export { ModalManager } from '@mui/base/Modal';
export { default } from './Modal';
export * from './Modal';